export const siteSettings = {
  name: "Pulse Digital Trade",
  link: "https://pulsedigitaltrade.com",
  email: "support@pulsedigitaltrade.com",
  appLink: "https://app.pulsedigitaltrade.com",
};
